'use client';

import getLabel from '@/assets/images/status/label-get.png';
import LinkButton from '@/components/form/LinkButton/LinkButton';
import CarouselModal from '@/components/ui/CarouselModal/CarouselModal';
import ImageView from '@/components/ui/ImageView/ImageView';
import { LOTTERY_STATUS } from '@/constants';
import { isGotGoods } from '@/features/lottery/utils';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { formatCurrency } from '@/utils/formatters';
import { useState } from 'react';
import type { LotteryCustomOption, LotteryDrawHistoryLineup, LotteryGoods } from '../../types';
import styles from './LotteryGoodsList.module.scss';

function LotteryGoodsList({
  goodsList,
  linupId,
  lotteryDrawHistory,
  liKeyPrefix = 'goods',
  lotteryStatus,
  customOptions,
}: {
  goodsList: Array<LotteryGoods>;
  linupId: number;
  lotteryDrawHistory?: Array<LotteryDrawHistoryLineup>;
  liKeyPrefix?: string;
  lotteryStatus: string;
  customOptions?: LotteryCustomOption;
}) {
  const [isScrollModalOpen, setIsScrollModalOpen] = useState(false);
  const [initShowImageUrlIndex, setInitShowImageUrlIndex] = useState(0);

  // const [_goodsModal, setGoodsModal] = useGoodsModalAtom();
  const openGoodsModal = (e: React.MouseEvent, goods: LotteryGoods) => {
    e.preventDefault();
    const clickedIndex = goodsList.findIndex((item) => item.id === goods.id);
    setInitShowImageUrlIndex(clickedIndex);
    setIsScrollModalOpen(true);
    // setGoodsModal({
    //   id: goods.id,
    //   isOpen: true,
    //   imageUrl: goods.imageUrl,
    //   name: goods.name,
    //   isGot: isGotGoods,
    // });
  };

  // 終了
  const isNotLater = lotteryStatus !== LOTTERY_STATUS.later.value;

  return (
    <>
      <ul className={styles.componentStyle}>
        {goodsList.map((goodsItem) => {
          const isGot = isGotGoods(linupId, goodsItem, lotteryDrawHistory);
          return (
            <li key={`${liKeyPrefix}_${linupId}_${goodsItem.id}`}>
              {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
              <a className={styles.goodsLink} onClick={(e) => openGoodsModal(e, goodsItem)}>
                <div className={styles.goodsImageWrapper}>
                  <div className={styles.goodsImage}>
                    <ImageView src={goodsItem.imageUrl} alt='景品' />
                    {isGot && <img className={styles.gotLabel} src={getLabel.src} alt='GET' />}
                  </div>
                </div>
                <p
                  className={`${styles.goodsName} ${utilsStyles.textBold} ${customOptions?.showAllPrizeGoodsNames === '1' ? styles.showAllPrizeGoodsNames : ''}`}
                >
                  {goodsItem.name}
                </p>
                {/* 開催終了後は出さない */}
                {isNotLater && goodsItem.isStockLimit && (
                  <p className={`${styles.itemStock} ${utilsStyles.textXSmall} ${utilsStyles.textRight}`}>
                    {formatCurrency(goodsItem.stock)}個
                  </p>
                )}
              </a>
            </li>
          );
        })}
        {dummy()}
      </ul>
      <CarouselModal
        initShowIndex={initShowImageUrlIndex}
        isOpen={isScrollModalOpen}
        close={() => setIsScrollModalOpen(false)}
        childrenArr={goodsList.map((goods) => {
          const isGot = isGotGoods(linupId, goods, lotteryDrawHistory);
          return (
            <div className={styles.goodsModal} key={goods.id}>
              <ImageView src={goods.imageUrl} alt={'景品'} isFreeSize />
              <div className={styles.modalPadding}>
                <div>
                  <em>{goods.name}</em>
                </div>
                {isGot && (
                  <div className={utilsStyles.mtXSmall}>
                    <LinkButton href={`/account/collection/${goods.id}`} size='fullWidth' outlined>
                      獲得した景品を見る
                    </LinkButton>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      />
    </>
  );
}

function dummy() {
  const result = [];
  for (let i = 0; i < 5; i++) {
    result.push(
      <li key={`dummy_${i}`} className={styles.dummy}>
        <div className={styles.goodsLink} />
      </li>,
    );
  }
  return result;
}

export default LotteryGoodsList;
